import React from 'react'
import _ from 'lodash'
import { Row } from 'antd'
import { P } from 'konsys-ui'
import contents from './detail/contents'
import CompoenentRenderer from './detail/component-renderer'
import { Wrapper } from '../../components/mechanics-components'
import { detailMode } from './constants'
import history from '../../history'

const RowRenderer = ({
  data, mode, onChangeHandler, initialData, skillData,
}) => data.map(v => <CompoenentRenderer onChangeHandler={(id, value) => onChangeHandler(id, value)} key={v.id} data={v} mode={mode} initialData={initialData} skillData={skillData}/>)

const DetailModeHandler = (params, onChangeHandler, skillData, initialData) => {
  const mode = params.mode.toUpperCase()
  switch (mode) {
    case detailMode.ADD:
      return contents.map((v, i) => (
        <Wrapper key={i}>
          <Row
            align='flex-start'
            // justify='center'
            type='flex'
            gutter={12}
            style={{ width: '100%' }}
          >
            <RowRenderer data={v} mode={mode} skillData={skillData} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
          </Row>
        </Wrapper>
      ))
    case detailMode.EDIT:
    case detailMode.VIEW:
    {
      if (_.isUndefined(params.id)) history.push('/driver')
      // mockup data
      return contents.map((v, i) => (
        <Wrapper key={i}>
          <Row
            align='flex-start'
            // justify='center'
            type='flex'
            gutter={12}
            style={{ width: '100%' }}
          >
            <RowRenderer data={v} mode={mode} skillData={skillData} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
          </Row>
        </Wrapper>
      ))
    }
    default:
      return <P>Something went wrong!</P>
  }
}

export default DetailModeHandler
